<template>
  <div style="background: #edece5; min-height: 100vh">
    <img class="logo" src="@/assets/lek/lek-logo-1280x1280.png" alt="LEK Logo" />
    <!-- 医院选择弹窗 -->
    <van-popup
      v-model="showHospitalSelector"
      position="right"
      style="width: 80%"
    >
      <hospital-selector
        :city="city"
        @select="selectHospital"
        @addCustom="addCustomHospital"
      />
    </van-popup>

    <!-- 自定义医院弹窗 -->
    <van-popup v-model="showCustomHospital" :style="{width: '80%'}">
      <div class="custom-hospital-popup">
        <van-field v-model="customHospitalName" placeholder="请输入医院名称" />
        <div class="button-group">
          <van-button
            round
            type="primary"
            style="margin-right: 20px"
            @click="confirmCustomHospital"
          >
            确定
          </van-button>
          <van-button round @click="showCustomHospital = false">
            取消
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 表单部分 -->
    <van-form
      class="register-form"
      style="padding-top: 60px"
      @submit="submitForm"
    >
      <van-cell-group style="background: none">
        <!-- 省市选择 -->
        <van-field
          readonly
          label="省市"
          :value="province && city ? `${province} ${city}` : ''"
          placeholder="省市"
          :rules="[{required: true, message: '请选择省市'}]"
          @click="showAreaPicker = true"
        >
          <template #left-icon><van-icon name="location-o" /></template>
        </van-field>

        <!-- 医院选择 -->
        <van-field
          readonly
          label="医院"
          :value="hospital"
          placeholder="医院"
          :rules="[{required: true, message: '请选择医院'}]"
          @click="
            province && city
              ? (showHospitalSelector = true)
              : $toast('请先选择省市')
          "
        >
          <template #left-icon><van-icon name="home-o" /></template>
          <template #right-icon><van-icon name="search" /></template>
        </van-field>

        <!-- 科室选择 -->
        <van-field
          readonly
          label="科室"
          :value="department"
          placeholder="科室"
          :rules="[{required: true, message: '请选择科室'}]"
          @click="showDepartmentPicker = true"
        >
          <template #left-icon><van-icon name="friends-o" /></template>
        </van-field>

        <!-- 职称选择 -->
        <van-field
          readonly
          label="职称"
          :value="title"
          placeholder="职称"
          :rules="[{required: true, message: '请选择职称'}]"
          @click="showTitlePicker = true"
        >
          <template #left-icon><van-icon name="manager-o" /></template>
        </van-field>

        <!-- 姓名输入 -->
        <van-field
          v-model="name"
          label="姓名"
          placeholder="姓名"
          :rules="[{required: true, message: '请输入姓名'}]"
        >
          <template #left-icon><van-icon name="user-o" /></template>
        </van-field>

        <!-- 手机号输入 -->
        <van-field
          v-model="phoneNumber"
          type="tel"
          label="手机"
          name="phoneRule"
          placeholder="手机号码"
          :rules="[{validator: phoneRule, message: '请输入正确的手机号码'}]"
        >
          <template #left-icon><van-icon name="phone-o" /></template>
        </van-field>
      </van-cell-group>
      <div style="display: flex; align-items: center; justify-content: center; margin-top: 35px; white-space: nowrap;">
        <van-checkbox v-model="checked" checked-color="#00b852" />
        <div style="font-size: 15px; margin-left: 10px;">
          <span @click="checked = !checked">我已阅读并同意</span><span style="color: #00b852" @click="showInstructions = true">《电子信息平台隐私政策》</span>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="submit-btn">
        <van-button type="primary" block round> 提交 </van-button>
      </div>
    </van-form>

    <!-- 各种选择器 -->
    <van-popup v-model="showAreaPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="provinceCityColumns"
        @confirm="onAreaConfirm"
        @cancel="showAreaPicker = false"
        @change="onAreaChange"
      />
    </van-popup>

    <van-popup v-model="showDepartmentPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="departments"
        @confirm="onDepartmentConfirm"
        @cancel="showDepartmentPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTitlePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="titles"
        @confirm="onTitleConfirm"
        @cancel="showTitlePicker = false"
      />
    </van-popup>

    <van-popup
      v-model="showInstructions"
      position="bottom"
      :style="{height: 'calc(100vh - 80px)'}"
      round
      closeable
    >
      <div class="terms-service">
        <p class="title">
          <strong>
            LEK电子信息平台隐私政策
          </strong>
        </p>
        <p>
          LEK（以下简称 “ LEK ” 或 “ 我们 ”
          ）一向重视用户（ “ 您 ”
          ）的个人信息及隐私的保护，我们深知个人信息对您的重要性，并严格遵循法律法规，竭力保障您的信息安全。鉴于此，我们制定本《LEK电子信息平台隐私政策》（下称
          “ 本隐私政策 ”
          ）并提醒您：本隐私政策适用于我们在中国大陆境内，通过LEK电子信息平台（电子信息平台是指借助电子信息化手段，提供文字、图片、音频、视频、直播、投票、签到、留言、调研、会议活动通知等信息的互动平台，以下简称
          “ 本平台 ”
          ）向您提供产品或服务时所有的个人信息处理活动。我们希望通过本隐私政策向您说明您在使用本平台时，我们如何收集、使用、保存、提供、删除、共享和转让这些个人信息，以及我们为您提供的查询、复制、删除和保护这些信息的方式。
        </p>
        <p>
          希望您仔细阅读本隐私政策，详细了解我们对个人信息的收集、使用、对外提供或其他处理的情况。您点击同意本隐私政策并开始使用本平台，表示您知悉并同意我们收集您的个人信息，并在法律规定及本隐私政策约定的范围内进行使用。如有问题，您可通过本隐私政策规定的方式与我们联系。
        </p>
        <p>1. 个人信息的收集和使用</p>
        <p>2. Cookie 和同类技术的使用</p>
        <p>3. 个人信息的存储</p>
        <p>4. 个人信息的处理和使用目的</p>
        <p>5. 个人信息的共享、转让和公开披露</p>
        <p>6. 个人信息的保护</p>
        <p>7. 禁止未经授权的扩散和传播</p>
        <p>8. 针对医疗卫生专业人士的特殊规定</p>
        <p>9. 本隐私政策更新</p>
        <p>10. 您的个人信息权利</p>
        <p>11. 未成年人保护</p>
        <p>12. 如何联系我们</p>
        <p><strong> 1. 个人信息的收集和使用 </strong></p>
        <p>
          个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。LEK数据隐私政策请参考：
          https://www.lundbeck.com/cn/cn/data-privacy-policy
        </p>
        <p>本平台可能出于本声明所描述的目的收集如下有关您的个人信息：</p>
        <p>(1) 您的姓名、详细专业信息、职业信息；</p>
        <p>(2) 您的微信账户信息、银行卡信息、身份证信息；</p>
        <p>(3) 您的联系方式；</p>
        <p>
          (4)
          您的个人在线行为记录（包括登录本平台的时间、登录时长、浏览时长、浏览次数、打开或浏览内容）。
        </p>
        <p>
          您理解并同意，LEK将通过电子化或线下沟通渠道向您提供LEK理解最适合您的信息，包括但不限于会议活动通知、研究进展、医学科学文献等等。基于您提供的不同的个人信息种类，LEK与您之间的电子化沟通渠道可能包含腾讯微信账号平台、网站等。为向您提供上述资讯服务，本平台可能自动收集您的个人数据（如您的个人在线行为轨迹，包括登录本平台的时间、登录时长、浏览时长、浏览次数、打开或浏览内容）。若您不希望被自动收集上述个人数据，您可以根据本声明
          “ 您的个人信息权利 ” 移除您的所有个人信息。
        </p>
        <p><strong> 2. Cookie 和同类技术的使用 </strong></p>
        <p>
          (1)
          为确保我们的产品、服务的正常开展、为您获得更轻松的访问体验，我们可能会在您的设备上存储名为
          Cookie 的小数据文件。 Cookie
          通常包含标识符、站点名称以及一些号码和字符 。
        </p>
        <p>
          (2) 我们或我们的第三方合作商，可能通过 Cookie
          及相关技术收集您的信息，目的是为您提供更加便捷的用户体验。我们亦会严格要求第三方合作商遵守本政策的相关规定
          。
        </p>
        <p>
          (3)
          如果您的LEK电子信息平台允许，您可以通过LEK电子信息平台设置启用、关闭或管理
          Cookie 。但请注意，如果停用 Cookie ，您可能无法使用部分功能 。
        </p>
        <p><strong> 3. 个人信息的存储 </strong></p>
        <p>
          (1)
          存储时间：我们仅会在达成本隐私政策所述目的所需的最短期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。在您主动注销账号或删除相关信息时，我们将根据法律法规的要求删除或匿名化处理您的个人信息。
        </p>
        <p>
          (2)
          存储地点：原则上，我们将在中华人民共和国境内存储您的个人信息。如需跨境传输，我们将另行征得您的同意。同时，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。
        </p>
        <p>
          (3)
          在您告知将终止使用LEK的通用账号和平台后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。
        </p>
        <p><strong> 4. 个人信息的处理和使用目的 </strong></p>
        <p>
          您同意，在您使用本平台的过程中，LEK可以收集、使用和处理您上述个人信息用作下列目的：
        </p>
        <p>
          (1)
          为本平台注册之目的，本平台可能从第三方（腾讯微信）获取您授权共享的账户信息
          ( 包括头像、昵称、联系方式 )
          ，并在您同意本声明并确认注册后将您的第三方账户（腾讯微信）与您在本平台的账户绑定，使您可以通过第三方账户（腾讯微信）直接登录并使用本平台。
        </p>
        <p>
          (2)
          您的姓名和详细专业信息用于身份验证及匹配以确认您是否为医疗卫生专业人士。
        </p>
        <p>
          (3)
          将您的联系方式用于与您联系并与您互动，包括通过网站、腾讯微信账号（包括腾讯微信消息、小程序、服务号或公众号定期文章推送等）、视频连线等电子化方式或线下沟通渠道与您联络，以及处理及跟进与您有关的来电、查询，反馈及问询。
        </p>
        <p>
          (4) 您的个人在线行为记录信息用于向您推送LEK理解的最适合您的信息。
        </p>
        <p><strong> 5. 个人信息的共享、转让和公开披露 </strong></p>
        <p>
          (1)
          我们将为您提供给我们的个人信息严格保密，在未经您同意之前，我们不会和任何第三方分享您的个人信息。
        </p>
        <p>
          (2)
          在本声明获得您的同意后，我们可能会为提供、维护、改善或提高我们的服务，与以下接收方分享您的个人信息：我们的关联公司、分支机构和
          / 或与本平台对接的其他LEK电子化信息平台。
        </p>
        <p>
          (3)
          除非本声明另有约定或者法律法规另有要求，除我们发生收购、兼并、重组等变更以外，您的个人信息不会转让给任何我们以外的第三方。在我们需要将您的个人信息转让给我们以外的任何第三方时，我们将向您告知相关的情况，变更后的本平台的运营主体将继续履行我们在本声明下的责任和义务。如果届时您所提供的个人信息的使用目的发生变化，其将重新取得您的同意。
        </p>
        <p>
          (4)
          除非本声明另有约定或者法律法规另有要求，非经您明确同意或基于您的主动提出，本平台不会公开披露您的个人信息。
        </p>
        <p>
          (5)
          尽管有上述约定，您知悉并理解，在以下情形下，本平台共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        </p>
        <p>(a) 与国家安全、国防安全直接相关的；</p>
        <p>(b) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>
          (c)
          为遵守中国或其它国家适用的法律、法规、规章、政府行政命令、行政程序、法院裁判或者仲裁裁决的需要的；
        </p>
        <p>
          (d)
          出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p>(e) 共享、转让、公开披露的个人信息已经过匿名化处理的；以及</p>
        <p>(f) 法律法规规定的其他情形。</p>
        <p><strong> 6. 个人信息的保护 </strong></p>
        <p>
          (1)
          LEK将采取适当的物理、管理和技术保护措施，包括采用符合行业标准的信息加密技术，对您的个人信息进行加密保存，旨在保护LEK收集和维护的个人信息的机密性、完整性和安全性，以防止意外或丢失、盗窃和滥用以及未经授权的访问、披露、更改销毁或任何其他类型的非法处理。
        </p>
        <p>
          (2)
          您理解并知悉，本平台将尽力确保您的个人信息的安全，但互联网并非绝对安全的环境，而且电子邮件、即时通讯等与其他用户的交流方式并未加密，本平台建议您不要通过此类方式发送个人信息以使用本平台的服务。
        </p>
        <p>
          (3) 在您的个人信息不幸发生泄露或其他涉及您个人信息安全的事件（ “
          个人信息安全事件 ”
          ）发生后，本平台将按照法律法规的要求，及时向您告知个人信息安全事件的基本情况和可能的影响、本平台已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。本平台将及时将个人信息安全事件的相关情况以推送通知方式告知您，难以逐一告知您时，本平台会采取合理、有效的方式发布公告。同时，本平台还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        </p>
        <p><strong> 7. 禁止未经授权的扩散和传播 </strong></p>
        <p>
          您理解并同意，您所接收的全部信息和 /
          或内容系LEK所有或系LEK经合理许可后提供，并受到LEK内部保密政策和中华人民共和国或其他相关地区法律的保护，在未得到LEK明确的书面许可之前，您不得对所接收信息的内容进行复制、仿制或再次传播，您亦不得通过电子媒介或复印件拷贝、截屏、展示、下载、传播、改写、仿制、再版或转发您所接收的任何信息，或者在这些信息的基础上创作它们的派生作品。
        </p>
        <p><strong> 8. 针对医疗卫生专业人士的特殊规定 </strong></p>
        <p>
          您理解并同意，LEK会做积极的努力提供最新的信息，但对其准确性、时效性和完整性不做任何形式的保证，也不承担任何责任。作为医疗卫生专业人士，那么您进一步理解并同意，您是作为医学领域独立的专业人士接受LEK提供的所有信息，并将对该等信息做出独立的医学判断；您的处方、推荐、采购和
          / 或其他专业行为和 /
          或决定将不会因LEK向您提供上述学术信息而受到任何不正当的影响。
        </p>
        <p><strong> 9. 本隐私政策更新 </strong></p>
        <p>
          在法律许可或在不侵犯您的法定权利的范围内，LEK保留修改或删除本声明或其任何部分的权利，我们将在该变更发生时在页面显著位置进行提示。在该种情况下，若您继续使用我们的服务或未拒绝接受更新的声明，即表示同意受修订后的声明约束。
        </p>
        <p><strong> 10. 您的个人信息权利 </strong></p>
        <p>
          在您使用小程序期间，按照中国相关的法律、法规、标准，您对您的个人信息享有以下权利：
        </p>
        <p>
          (1)
          查询、复制、更正的权利：您可通过下方【如何联系我们】所述方式，提出查询、复制、更正我们保有的有关您的个人信息的要求，法律法规规定的例外情况除外。
        </p>
        <p>
          (2) 删除权：在以下情形中，您可以向我们提出删除您的其他个人信息的请求：
        </p>
        <p>1) 处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
        <p>2) 当我们停止提供产品或者服务，或者保存期限已届满；</p>
        <p>3) 您撤回同意后；</p>
        <p>4) 若我们违反法律、行政法规或者违反约定处理个人信息；</p>
        <p>5) 法律、行政法规规定的其他情形</p>
        <p>
          当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息，且您删除信息后，我们不会再继续使用您的个人信息。
        </p>
        <p>
          (3)
          改变或撤回您授权同意的范围：您可通过下方【如何联系我们】所述方式，向我们提出改变或撤回您授权我们收集和处理您的个人信息的范围，当您撤回同意后，我们将不再处理相应的个人信息。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但您撤回同意的决定，将不会影响我们此前基于您的授权而开展的个人信息处理。
        </p>
        <p>
          (4)
          注销账号：您可通过下方【如何联系我们】所述方式，向我们提出注销账号的要求。我们会在您的账号被注销后对您的相关个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
        </p>
        <p>
          (5) 要求解释说明：
          您有权要求我们对您的个人信息处理的规则进行解释说明，您可以通过本隐私政策【如何联系我们】章节说明的方式与我们联系，我们会在法律要求的时限内满足您的合法请求。
        </p>
        <p>
          (6) 死者近亲属权利：
          已故用户的近亲属为了自身的合法、正当利益，可以对已故用户的相关个人信息行使本章规定的查阅、复制、更正、删除等权利；已故用户生前另有安排的除外。已故用户的近亲属可以通过本隐私政策【如何联系我们】章节说明的方式与我们联系，我们会在法律要求的时限内满足您的合法请求。
        </p>
        <p>
          (7) 响应您的上述请求：
          为保障安全，我们可能会先要求验证您的身份（如要求您提供书面资料或其他方式），然后再处理您的上述请求。我们将在收到相关请求并验证您的身份后在法定允许的期限内响应您的请求。
        </p>
        <p>
          (8)
          请您理解，按照特定的法律法规要求，我们可能无法响应您的一些请求，例如，与国家安全、公共利益、履行我们法定义务相关的，以及涉及商业秘密等情形。
        </p>
        <p><strong> 11. 未成年人保护 </strong></p>
        <p>
          我们的产品、网站和服务只面向成人， 18
          岁以下的未成年人不应创建自己的账号。未取得未成年人的父母或其他监护人的同意，我们不会主动收集未成年人的个人信息。如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
        </p>
        <p><strong> 12. 如何联系我们 </strong></p>
        <p>如果您对本政策有任何疑问、意见或建议，可通过以下方式与我们联系：</p>
        <p>公司名称：LEK</p>
        <p>
          注册地址：北京市朝阳区东大桥路 9 号楼 1 单元 11 层 1101 室内 A01-06
          单元
        </p>
        <p>联系方式： china_data@lundbeck.com</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getLocalStorage } from '@/utils/index';
import HospitalSelector from '@/components/hospital-selector.vue';
import {getKvpProvinceAndCities, getKvpProfessionalTitles, getKvpDepartments, Register} from '@/api/live';
import {
  Popup,
  Field,
  Button,
  CellGroup,
  Icon,
  Picker,
  Form,
  Checkbox,
} from 'vant';

export default {
  components: {
    HospitalSelector,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Form.name]: Form,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      content_id: '',
      open_id: '',
      hospital: '',
      customHospitalName: '',
      name: '',
      province: '',
      city: '',
      department: '',
      title: '',
      phoneNumber: '',
      dataProvinceAndCities: [],
      provinces: [],
      cities: [],
      showHospitalSelector: false,
      showCustomHospital: false,
      showAreaPicker: false,
      showDepartmentPicker: false,
      showTitlePicker: false,
      provinceCityColumns: [{values: []}, {values: []}],
      departments: [],
      titles: [],
      checked: false,
      showInstructions: false,
    };
  },
  watch: {
    city(newCity) {
      console.log('City changed:', newCity);
    },
  },
  created() {
    this.open_id = getLocalStorage('open_id');
    const urlParams = new URLSearchParams(window.location.search);
    this.content_id = urlParams.get('cid');

    if (!this.open_id) {
      window.location.href = `/public/live?cid=${this.content_id}`;
    } else {
      getKvpProvinceAndCities().then((res) => {
        this.dataProvinceAndCities = res.value;
        this.provinces = this.dataProvinceAndCities
          .filter((item) => item.kvp_id === 'province')
          .map((item) => item.chs);
        this.updateCities(0);
        this.provinceCityColumns[0].values = this.provinces;
        this.provinceCityColumns[1].values = this.cities;
      });
      getKvpProfessionalTitles().then((res) => {
        this.titles = res.value.map((item) => item.kvp_key_name);
      });
      getKvpDepartments().then((res) => {
        this.departments = res.value.map((item) => item.kvp_key_name);
      });
    }
  },
  methods: {
    onAreaChange(picker, values) {
      const provinceIndex = this.provinces.indexOf(values[0]);
      if (provinceIndex !== -1) {
        this.updateCities(provinceIndex);
        picker.setColumnValues(1, this.cities);
      }
    },
    onAreaConfirm(value) {
      this.province = value[0];
      this.city = value[1];
      this.showAreaPicker = false;
    },
    onDepartmentConfirm(value) {
      this.department = value;
      this.showDepartmentPicker = false;
    },
    onTitleConfirm(value) {
      this.title = value;
      this.showTitlePicker = false;
    },
    selectHospital(hospital) {
      console.log('hospital---->', hospital);
      this.hospital = hospital;
      this.showHospitalSelector = false;
    },
    addCustomHospital() {
      this.showHospitalSelector = false;
      this.showCustomHospital = true;
    },
    confirmCustomHospital() {
      this.hospital = this.customHospitalName;
      this.showCustomHospital = false;
    },
    updateCities(provinceIndex) {
      const selectedProvince = this.provinces[provinceIndex];
      const provinceKey = this.dataProvinceAndCities.find(
        (item) => item.chs === selectedProvince && item.kvp_id === 'province',
      ).kvp_key_id;
      this.cities = this.dataProvinceAndCities
        .filter((item) => item.parent_kvp_key_id === provinceKey)
        .map((item) => item.chs);
      this.hospital = '';
    },
    submitForm() {
      if (!this.checked) {
        this.$toast('请阅读并勾选《信息处理知情同意书》');
        return;
      }
      const data = {
        open_id: this.open_id,
        physician_name: this.name,
        institution_name: this.hospital,
        province: this.province,
        city: this.city,
        department_name: this.department,
        professional_title: this.title,
        mobile_phone: this.phoneNumber,
        is_consent: this.checked,
      };
      console.log('data---->', data);
      Register(data).then((res) => {
        if (res.isSuccess) {
          window.location.href = `/public/live?cid=${this.content_id}`;
        } else {
          this.$toast('注册失败，请稍后再试。' + res.message);
        }
      });
    },
    phoneRule(val) {
      return /^1[3-9]\d{9}$/.test(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 80px;
  height: 80px;
  margin: 30px 0 0 0;
}
.register-form {
  padding: 20px 35px;
}

.submit-btn {
  margin-top: 20px;
  padding: 0;
}

.custom-hospital-popup {
  padding: 20px;

  .button-group {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .van-button {
      width: 100px;
      margin-bottom: 10px;
    }
  }
}
::v-deep .register-form .van-cell {
  margin-bottom: 15px;
  border-radius: 40px;
}

::v-deep .van-field__label {
  width: 50px;
}
// ::v-deep .van-field__error-message {
//   display: none;
// }
.terms-service {
  padding: 0 20px;
  background-color: #ffffff;
  overflow: auto;
  margin-top: 50px;
  height: calc(100vh - 125px);

  text-align: left;
  font-size: 14px;

  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    margin: 10px 0 30px 0;
    color: #00b852;
  }

  strong {
    font-weight: bold;
  }

  p {
    margin: 10px 0;
  }

  .myself {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    margin: 20px 0 10px 0;
    width: 100%;
    color: #333;
    .highlight {
      font-weight: bold;
      // color: #00b852;
      // text-decoration: underline;
    }
  }

  .content {
    .section {
      margin-bottom: 20px;

      .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        text-align: left;
        margin-bottom: 30px;
      }

      .section-text {
        font-size: 14px;
        line-height: 1.6;
        color: #333;
        margin-bottom: 15px;
        text-align: justify;
      }
    }
  }

  .button-group {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    .form-input {
      width: 90%;
      height: 44px;
      border: 1px solid #eee;
      border-radius: 30px;
      padding: 0 15px;
      font-size: 16px;
      color: #333;
      background: #fff;
      text-align: center;

      &:disabled {
        background: #fff;
        color: #666;
      }

      &::placeholder {
        color: #999;
      }
    }

    button {
      width: 100%;
      height: 44px;
      border-radius: 22px;
      border: none;
      font-size: 16px;
      cursor: pointer;

      &.agree-btn {
        margin-top: 5px;
        background: #00b852;
        color: #ffffff;
      }
      &.reject-btn {
        // margin-top: 40px;
        background: #22201f;
        color: #ffffff;
      }
    }
    .separator {
      margin: 40px 0;
      width: 80%;
      height: 1px;
      border-top: 2px dashed #eeeee0;
    }
  }
}
</style>
